import script from "./RewardImageLightbox.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardImageLightbox.vue?vue&type=script&setup=true&lang=js"

import "./RewardImageLightbox.vue?vue&type=style&index=0&id=5350368f&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5350368f"]])

export default __exports__